import { ref } from "vue";

export const showModalBasketHappy = ref(false)
export const showModalBasketHappyTransition = ref(false)